import { SAFE_PLACE_TYPE } from "@dpdgroupuk/redback-enums";

import * as M from "../../constants/strings";
import { Fields } from "../../constants/forms";
import { EMAIL, PHONE_NUMBER, POSTCODE } from "./regex";
import { checkIfPostcodeValid } from "../postcode";

export const notificationDetailsValidator = values => {
  const errors = {};
  let phoneWithoutSpaces = values.mobile?.replace(/\s+/g, "");

  if (phoneWithoutSpaces?.match(/^\+/)) {
    phoneWithoutSpaces = phoneWithoutSpaces.substring(1); // remove +
  }

  if (!values.contactName) {
    errors.contactName = M.PROVIDE_CONTACT_NAME;
    errors._error = M.PROVIDE_CONTACT_NAME;
  }

  if (!values.mobile && !values.email) {
    errors.mobile = M.PROVIDE_PHONE_EMAIL;
    errors.email = M.PROVIDE_PHONE_EMAIL;
    errors._error = M.PROVIDE_PHONE_EMAIL;
  }

  if (
    values.mobile &&
    (!PHONE_NUMBER.test(values?.mobile) ||
      phoneWithoutSpaces?.length < 7 ||
      phoneWithoutSpaces?.length > 15)
  ) {
    errors.mobile = M.ENTER_VALID_PHONE;
    errors._error = M.ENTER_VALID_PHONE;
  }

  if (values.email && !EMAIL.test(values.email)) {
    errors.email = M.ENTER_VALID_EMAIL;
    errors._error = M.ENTER_VALID_EMAIL;
  }

  return errors;
};

export const safePlaceValidator = values => {
  const errors = {};

  if (values.isDatesAvailable && !values.deliveryDate) {
    errors.deliveryDate = M.DELIVERY_DATE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_DATE_MUST_BE_SELECTED;
  }

  if (!values.safePlaceCode) {
    errors.safePlaceCode = M.SAFE_PLACE_MUST_BE_SELECTED;
    errors._error = M.SAFE_PLACE_MUST_BE_SELECTED;
  }

  if (values.safePlaceCode === SAFE_PLACE_TYPE.OTH && !values.instructions) {
    errors.instructions = M.SELECT_OTHER_AND;
    errors._error = M.SELECT_OTHER_AND;
  }

  if (!values.agreement) {
    errors.agreement = M.ACCEPT_CONDITIONS;
    errors._error = M.ACCEPT_CONDITIONS;
  }

  if (values.contactName && values.contactName.trim().length > 35) {
    errors.contactName = M.MAX_35_CHARACTERS;
    errors._error = M.MAX_35_CHARACTERS;
  }

  return errors;
};

export const deliverToNeighbourValidator = values => {
  const errors = {};

  if (values.isDatesAvailable && !values.deliveryDate) {
    errors.deliveryDate = M.DELIVERY_DATE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_DATE_MUST_BE_SELECTED;
  }

  if (!values.neighbourAddress) {
    errors.neighbourAddress = M.NEIGHBOUR_MUST_BE_SELECTED;
    errors._error = M.NEIGHBOUR_MUST_BE_SELECTED;
  }

  return errors;
};

export const changeDeliveryDateValidator = values => {
  const errors = {};

  if (!values.deliveryDate) {
    errors.deliveryDate = M.DELIVERY_DATE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_DATE_MUST_BE_SELECTED;
  }

  return errors;
};

export const updateContactDetails = values =>
  notificationDetailsValidator(values);

export const provideDeliveryInstructions = values => {
  const errors = {};

  if (!values.instructions) {
    errors.instructions = M.PLEASE_PROVIDE_INSTRUCTIONS;
    errors._error = M.PLEASE_PROVIDE_INSTRUCTIONS;
  }

  return errors;
};

export const returnToConsignor = values => {
  const errors = {};

  if (!values.isInternationalParcel) {
    errors.isInternationalParcel = M.ACCEPT_CONDITIONS;
    errors._error = M.ACCEPT_CONDITIONS;
  }

  if (!values.deliveryName) {
    errors.deliveryName = M.PROVIDE_NAME;
    errors._error = M.PROVIDE_NAME;
  }

  if (!values.deliveryCountryName) {
    errors.deliveryCountryName = M.PROVIDE_COUNTRY;
    errors._error = M.PROVIDE_COUNTRY;
  }

  if (
    values.deliveryPostcode &&
    !values.deliveryPostcode.match(POSTCODE) &&
    values.deliveryCountryName === "UK"
  ) {
    errors.deliveryPostcode = M.ENTER_VALID_POSTCODE;
    errors._error = M.ENTER_VALID_POSTCODE;
  }

  if (!values.deliveryPostcode) {
    errors.deliveryPostcode = M.PROVIDE_POSTCODE;
    errors._error = M.PROVIDE_POSTCODE;
  }

  if (!values.address) {
    errors.address = M.SELECT_RETURNED_ADDRESS;
    errors._error = M.SELECT_RETURNED_ADDRESS;
  }

  if (!values.deliveryCity) {
    errors.deliveryCity = M.PROVIDE_CITY;
    errors._error = M.PROVIDE_CITY;
  }

  if (values.deliveryCity && values.deliveryCity.trim().length > 50) {
    errors.deliveryCity = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  if (!values.deliveryStreet) {
    errors.deliveryStreet = M.PROVIDE_STREET;
    errors._error = M.PROVIDE_STREET;
  }

  if (values.deliveryStreet && values.deliveryStreet.trim().length > 50) {
    errors.deliveryStreet = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  if (values.sendersReference && values.sendersReference.trim().length > 50) {
    errors.sendersReference = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  return errors;
};

export const alternativeAddress = (values, props) => {
  const errors = {};

  if (!values.deliveryDate) {
    errors.deliveryDate = M.DELIVERY_DATE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_DATE_MUST_BE_SELECTED;
  }

  if (!values.name) {
    errors.name = M.PROVIDE_NAME;
    errors._error = M.PROVIDE_NAME;
  }

  if (!values.city) {
    errors.city = M.PROVIDE_CITY;
    errors._error = M.PROVIDE_CITY;
  }

  if (!values.street) {
    errors.street = M.PROVIDE_STREET;
    errors._error = M.PROVIDE_STREET;
  }

  if (!values.agreement) {
    errors.agreement = M.ACCEPT_CONDITIONS;
    errors._error = M.ACCEPT_CONDITIONS;
  }

  if (props.isPostcodeRequired && !values.postcode) {
    errors.postcode = M.PROVIDE_POSTCODE;
    errors._error = M.PROVIDE_POSTCODE;
  }

  if (props.isPostcodeRequired && values.postcode) {
    const isPostcodeValid = checkIfPostcodeValid({
      postcode: values.postcode,
      countryCode: values.countryCode,
      countries: props.countries,
    });

    if (!isPostcodeValid) {
      errors.postcode = M.ENTER_VALID_POSTCODE;
      errors._error = M.ENTER_VALID_POSTCODE;
    }
  }

  if (values.sendersReference && values.sendersReference.trim().length > 50) {
    errors.sendersReference = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  if (values.name && values.name.trim().length > 50) {
    errors.name = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  if (values.street && values.street.trim().length > 50) {
    errors.street = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  if (values.city && values.city.trim().length > 50) {
    errors.city = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  return errors;
};

export const alternativeAddressAndService = (values, props) => {
  const errors = alternativeAddress(values, props);

  if (!values.deliveryService) {
    errors.deliveryService = M.DELIVERY_SERVICE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_SERVICE_MUST_BE_SELECTED;
  }

  return errors;
};

export const callMe = values => {
  const errors = notificationDetailsValidator(values);

  if (!values.notes) {
    errors.notes = M.SELECT_OTHER_AND;
    errors._error = M.SELECT_OTHER_AND;
  }

  return errors;
};

export const adjustService = values => {
  const errors = {};

  if (!values.freeOfCharge) {
    errors.freeOfCharge = M.ACCEPT_CONDITIONS;
    errors._error = M.ACCEPT_CONDITIONS;
  }

  if (!values.deliveryDate) {
    errors.deliveryDate = M.DELIVERY_DATE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_DATE_MUST_BE_SELECTED;
  }

  if (!values.serviceCode) {
    errors.serviceCode = M.DELIVERY_SERVICE_MUST_BE_SELECTED;
    errors._error = M.DELIVERY_SERVICE_MUST_BE_SELECTED;
  }

  if (values.sendersReference && values.sendersReference.trim().length > 50) {
    errors.sendersReference = M.MAX_50_CHARACTERS;
    errors._error = M.MAX_50_CHARACTERS;
  }

  return errors;
};

export const collectFromPickupShop = values => {
  const errors = notificationDetailsValidator(values);

  if (!values.pickupLocationCode) {
    errors.pickupLocationCode = M.INVALID_PICKUP_LOCATION_CODE;
    errors._error = M.INVALID_PICKUP_LOCATION_CODE;
  }

  if (!values.pickupDate) {
    errors.pickupDate = M.INVALID_PICKUP_DATE;
    errors._error = M.INVALID_PICKUP_DATE;
  }

  return errors;
};

export const collectFromDepot = values => {
  const errors = notificationDetailsValidator(values);

  if (!values.diaryDate) {
    errors.diaryDate = M.COLLECTION_DATE_MUST_BE_SELECTED;
    errors._error = M.COLLECTION_DATE_MUST_BE_SELECTED;
  }

  if (!values.diaryTime) {
    errors.diaryTime = M.COLLECTION_TIME_MUST_BE_SELECTED;
    errors._error = M.COLLECTION_TIME_MUST_BE_SELECTED;
  }

  return errors;
};

export const disposeRequest = values => {
  const errors = {};

  if (!values.agreement) {
    errors.agreement = M.TICK_CHECKBOX;
    errors._error = M.TICK_CHECKBOX;
  }

  return errors;
};

export const uploadDocumentToVault = (values, { selectedDocumentType }) => {
  const errors = {};
  const document = values[Fields.DOCUMENT];

  if (!values[Fields.DOCUMENT_TYPE]) {
    errors[Fields.DOCUMENT_TYPE] = M.PLEASE_SELECT_DOCUMENT_TYPE;
    errors._error = M.PLEASE_SELECT_DOCUMENT_TYPE;
  }

  if (!document) {
    errors[Fields.DOCUMENT] = M.PLEASE_SELECT_FILE;
    errors._error = M.PLEASE_SELECT_FILE;
  }

  if (document && selectedDocumentType) {
    const fileExtension = document.name.split(".").pop().toLowerCase();

    if (
      selectedDocumentType.fileTypes.length &&
      fileExtension !== selectedDocumentType.fileTypes[0].toLowerCase()
    ) {
      errors._error = M.INVALID_FORMAT;
      return errors;
    }

    const maxSizeInBytes =
      selectedDocumentType.dims[fileExtension].maxSizeInKB * 1024;

    if (document.size > maxSizeInBytes) {
      errors._error = M.INVALID_FILE_SIZE;
    }
  }

  return errors;
};
